import { HATA_MESAJLARI, type HataKodu } from '@hotelcms/shared';
import { ApiHatasi } from './api';

/**
 * Platform yonetim paneli istemcisi.
 *
 * Kiraci istemcisinden (lib/api.ts) BILEREK ayridir: token anahtarlari
 * farklidir, boylece bir otel oturumu ile platform oturumu birbirine
 * karismaz ve yanlislikla capraz gonderim olmaz.
 */

const TOKEN = 'otelcms.platform.token';
const YENILEME = 'otelcms.platform.refresh';

export const platformOturum = {
  token: () => localStorage.getItem(TOKEN),
  refresh: () => localStorage.getItem(YENILEME),
  yaz(access: string, refresh: string) {
    localStorage.setItem(TOKEN, access);
    localStorage.setItem(YENILEME, refresh);
  },
  temizle() {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(YENILEME);
  },
};

async function coz<T>(cevap: Response): Promise<T> {
  if (cevap.ok) return (await cevap.json()) as T;
  let kod: HataKodu = 'SUNUCU_HATASI';
  let mesaj: string = HATA_MESAJLARI.SUNUCU_HATASI;
  let alan: string | undefined;
  try {
    const g = (await cevap.json()) as { hata?: { kod: HataKodu; mesaj: string; alan?: string } };
    if (g.hata) {
      kod = g.hata.kod;
      mesaj = g.hata.mesaj;
      alan = g.hata.alan;
    }
  } catch {
    /* JSON degil */
  }
  throw new ApiHatasi(kod, mesaj, cevap.status, alan);
}

export async function adminApi<T>(yol: string, init: RequestInit = {}): Promise<T> {
  const basliklar = new Headers(init.headers);
  const token = platformOturum.token();
  if (token) basliklar.set('authorization', `Bearer ${token}`);
  if (init.body) basliklar.set('content-type', 'application/json');

  const cevap = await fetch(`/api/admin${yol}`, { ...init, headers: basliklar });

  if (cevap.status === 401 && platformOturum.refresh()) {
    const yenilendi = await tokenYenile();
    if (yenilendi) return adminApi<T>(yol, init);
  }
  return coz<T>(cevap);
}

async function tokenYenile(): Promise<boolean> {
  const refresh = platformOturum.refresh();
  if (!refresh) return false;
  try {
    const cevap = await fetch('/api/admin/yenile', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ refresh }),
    });
    if (!cevap.ok) {
      platformOturum.temizle();
      return false;
    }
    const g = (await cevap.json()) as { access: string; refresh: string };
    platformOturum.yaz(g.access, g.refresh);
    return true;
  } catch {
    return false;
  }
}
